export const POS_INV_LOADING = "POS_INV_LOADING";
export const POS_INV_DASHBOARD = "POS_INV_DASHBOARD";
export const POS_INV_ITEMS = "POS_INV_ITEMS";
export const POS_INV_MOVEMENTS = "POS_INV_MOVEMENTS";
